import { render, staticRenderFns } from "./CurrentDate.vue?vue&type=template&id=7104954a&scoped=true&"
import script from "./CurrentDate.vue?vue&type=script&lang=js&"
export * from "./CurrentDate.vue?vue&type=script&lang=js&"
import style0 from "./CurrentDate.vue?vue&type=style&index=0&id=7104954a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104954a",
  null
  
)

export default component.exports